import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { HTMLAttributes } from 'vue'
import { reactiveOmit } from '@vueuse/core'
import { ChevronDown } from 'lucide-vue-next'
import { SelectScrollDownButton, type SelectScrollDownButtonProps, useForwardProps } from 'reka-ui'
import { cn } from '@/lib/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectScrollDownButton',
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] },
    class: {}
  },
  setup(__props: any) {

const props = __props

const delegatedProps = reactiveOmit(props, 'class')

const forwardedProps = useForwardProps(delegatedProps)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SelectScrollDownButton), _mergeProps({ "data-slot": "select-scroll-down-button" }, _unref(forwardedProps), {
    class: _unref(cn)('flex cursor-default items-center justify-center py-1', props.class)
  }), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createVNode(_unref(ChevronDown), { class: "size-4" })
      ])
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})